import './box.css'

import Button from 'react-bootstrap/esm/Button';
import Container from "react-bootstrap/esm/Container";
import { useDispatch, useSelector } from 'react-redux';

import BottomBar from '../../../../components/BottomBar';
import TitleBar from "../../../../components/TitleBar";
import { setHopiFlag, setTosFlag } from "../../slice";
import { inquiryUrl } from "../../urls";
import { hopiMain, tosMain } from '../../../Home/pages/Home';


const Consent = () => {
  const tosFlag = useSelector((state) => state.inquiry.tosFlag);
  const hopiFlag = useSelector((state) => state.inquiry.hopiFlag);
  const dispatch = useDispatch();

  const type = (new URL(document.location)).searchParams.get('type');
  const title = type === 'account' ? '新規アカウント申請' : 'お問い合わせ';
  const titleEn = type === 'account' ? 'Application for a New Account' : 'Inquiry';
  const titleEnSentence = type === 'account' ? 'To apply for a new account' : 'To inquire'

  const headline = (
    <>
      <div className='headline'>
        <h2>{title}について</h2>
        <h5><div className='en'>{titleEn}</div></h5>
        <div className='notice'>
          {title}については、<u>利用条件および個人情報取扱条件に同意いただく必要があります。</u><br />下記をお読みいただき、同意いただける場合は、チェックのうえ、入力画面にお進みください。<br />
          <div className='en'>
            {titleEnSentence}, <u>you are required to agree to the Terms of Usage and Privacy Policy.</u>
            <br />
            Please read the following and, if you agree, check the box before proceeding to the application page.
          </div>
        </div>
      </div>
    </>
  );

  const termsOfService = (
    <div className='unit'>
      <h3>Ｅ－ディフェンス実験データアーカイブ (ASEBI)の利用条件</h3>
      <h5><div className='en'>Terms of Use for Archives of Shakingtable Experimentation dataBase and Information (ASEBI)</div></h5>
      <div className="box">
        <div className="text">
          {tosMain}
        </div>
      </div>
      <div>
        <label className='checkbox'>
          <input type='checkbox' onClick={() => {
            if (!tosFlag) {
              dispatch(setTosFlag(true));
              // dispatch(setHopiFlag(hopiFlag));
            } else {
              dispatch(setTosFlag(false));
              // dispatch(setHopiFlag(hopiFlag));
            }
          }} />&nbsp;&nbsp;利用条件に同意する&nbsp;&nbsp;&nbsp;<div className='en'>I agree to the Terms of Use</div>
        </label>
      </div>
    </div>
  );

  const headingOfPersonalInformation = (
    <>
      <h3>個人情報取扱について</h3>
      <h5><div className='en'>Privacy Policy</div></h5>
      <div className="box">
        <div className="text">
          {hopiMain}
        </div>
      </div>
      <div>
        <label className='checkbox'>
          <input type='checkbox' onClick={() => {
            if (!hopiFlag) {
              // dispatch(setTosFlag(tosFlag));
              dispatch(setHopiFlag(true));
            } else {
              // dispatch(setTosFlag(tosFlag));
              dispatch(setHopiFlag(false));
            }
          }} />&nbsp;&nbsp;個人情報取扱に同意する&nbsp;&nbsp;&nbsp;<div className='en'>I agree to the Privacy Policy</div>
        </label>
      </div>
    </>
  )

  const consentButton = (
    <>
      <div className='button'>
        <Button to={inquiryUrl()} onClick={() => {
          if (!tosFlag || !hopiFlag) {
            alert(`利用条件、個人情報取扱に同意しない場合は${title}ができません。\nIf you do not agree to the Terms of Use and Privacy Policy, you will not be able to make inquiries or applications.`);
          } else {
            window.location.href = inquiryUrl(type);
          }
        }}>次へ&nbsp;&nbsp;&nbsp;Next</Button>
      </div>
    </>
  )

  return (
    <>
      <TitleBar />
      <Container>
        <div className='container'>
          {headline}
          {termsOfService}
          {headingOfPersonalInformation}
          {consentButton}
        </div>
      </Container>
      <div className='blank'></div>
      <BottomBar />
    </>
  );
};

export default Consent;